import Typography from "../../../../ui/widgets/typography";
import { Grid } from "@mui/material";
import InputContainer from "../../../../ui/layout/page/forms-container/form-item-container/input-container";
import Phone from "../../../shared/components/phone";
import Email from "../../../shared/components/email";
import React, { useContext, useState } from "react";
import { CardholderFormProps } from "../types";
import { ScdAccordion } from "../../../../ui/widgets/accordion";
import { ScdAccordionSummary } from "../../../../ui/widgets/accordion/summary";
import { ScdAccordionDetails } from "../../../../ui/widgets/accordion/details";
import get from "lodash.get";
import { CardholderFormikContext } from "../../context";
import { useMessageSource } from "react-message-source";

interface ContactAccordionProps {
  dataPath: string;
  phoneBusiness: CardholderFormProps["phoneBusiness"];
  mobile: CardholderFormProps["mobile"];
  emailBusiness: CardholderFormProps["emailBusiness"];
  isSameAsAdmin: CardholderFormProps["isSameAsAdmin"];
}

export const ContactAccordion = ({
  dataPath,
  emailBusiness,
  mobile,
  phoneBusiness,
  isSameAsAdmin,
}: ContactAccordionProps) => {
  const { errors, touched, values } = useContext(CardholderFormikContext);
  const { getMessage: t } = useMessageSource();

  const [isAccordionExpanded, setIsAccordionExpanded] = useState<boolean>(
    () => {
      const mobileHasErrorsAndTouchedAndEmpty =
        (get(errors, `${dataPath}mobile`) &&
          get(touched, `${dataPath}mobile`)) ||
        !get(values, `${dataPath}mobile.number`);

      const emailBusinessHasErrorsAndTouchedAndEmpty =
        (get(errors, `${dataPath}emailBusiness`) &&
          get(touched, `${dataPath}emailBusiness`)) ||
        !get(values, `${dataPath}emailBusiness`);

      const phoneBusinessHasErrorsAndTouchedAndEmpty =
        (get(errors, `${dataPath}phoneBusiness`) &&
          get(touched, `${dataPath}phoneBusiness`)) ||
        !get(values, `${dataPath}phoneBusiness.number`);

      const isAccordionExpandedFlag =
        mobileHasErrorsAndTouchedAndEmpty ||
        emailBusinessHasErrorsAndTouchedAndEmpty ||
        phoneBusinessHasErrorsAndTouchedAndEmpty;

      return Boolean(isAccordionExpandedFlag);
    },
  );

  const handleAccordionChange = (
    _: React.SyntheticEvent,
    isExpanded: boolean,
  ) => {
    setIsAccordionExpanded(isExpanded);
  };

  return (
    <ScdAccordion
      expanded={isAccordionExpanded}
      onChange={handleAccordionChange}
    >
      <ScdAccordionSummary>
        <Typography variant="body2">{t("Contact")}</Typography>
      </ScdAccordionSummary>
      <ScdAccordionDetails>
        <Grid className="scd-container-base" container>
          <InputContainer>
            <Phone
              dataPath={dataPath}
              value={phoneBusiness}
              isPrivate={false}
            />
          </InputContainer>
          <InputContainer>
            <Phone
              dataPath={dataPath}
              value={mobile}
              isMobile
              disabled={isSameAsAdmin}
            />
          </InputContainer>
          <InputContainer>
            <Email
              dataPath={dataPath}
              value={emailBusiness}
              isPrivate={false}
              disabled={isSameAsAdmin}
            />
          </InputContainer>
        </Grid>
      </ScdAccordionDetails>
    </ScdAccordion>
  );
};
